import { render } from "./SearchResult.vue?vue&type=template&id=5747dd50&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=ts"
export * from "./SearchResult.vue?vue&type=script&lang=ts"

import "./SearchResult.vue?vue&type=style&index=0&id=5747dd50&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5747dd50"

export default script